var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-section',[_c('heading',{attrs:{"header":_vm.page.heading}}),_c('section-list',{staticClass:"p-services__list",attrs:{"type":"service"}})],1),_c('builder',{attrs:{"builder":_vm.page.builder}}),_c('push')],1)}
var staticRenderFns = []

export { render, staticRenderFns }